import { getAllKeys } from '@iotv/datamodel-core';
import { useEffect, useState } from 'react';
import { getUniqueTypesMap, getViewDefinitionFromUniqueKeyTypes } from '../../../components/io/sharedFns';
import { viewDefinitionToGridColumnMap } from '../../../v2/components/generic/transformFns';
import { defaultRowToObject } from './transfromers';
import { useGoogleSpreadsheetDataImport } from './useGoogleSpreadsheetDataImport';
const debug = process.env.REACT_APP_DEBUG && false;
/**
 * A low level hook that accepts Google-compatible value arrays and imports from GSheets
 *
 * This hook should not be used in higher order componets where VOB manipulation is needed, use another wrapping hook
 */
export const useGoogleRowImport = ({ getRequest: getRequestIn, provideImportButton, rowToObjectFunction = defaultRowToObject, }) => {
    const [processedSpreadsheetData, setProcessedSpreadsheetData] = useState();
    const [columnHeaders, setColumnHeaders] = useState(null);
    const [gridColumnMap, setGridColumnMap] = useState(null);
    const [getRequest, setGetRequest] = useState(getRequestIn);
    const { range, spreadsheetId, dateTimeRenderOption, valueRenderOption } = getRequestIn ?? {};
    useEffect(() => {
        setGetRequest(getRequestIn);
    }, [range, spreadsheetId, dateTimeRenderOption, valueRenderOption]);
    const { state: { error, setSpreadsheetData, spreadsheetData }, components: { WorkingSpinner, ImportButton }, handlers: { clearError }, } = useGoogleSpreadsheetDataImport({ getRequest, provideImportButton });
    useEffect(() => {
        if (spreadsheetData) {
            /** This potentially is yet another hook */
            /** if first row is headers */
            const [headerRow, ...rows] = spreadsheetData;
            if (headerRow) {
                const sourceSheetColumnIndexedKeys = headerRow.map((header, i) => header?.toString() ?? i.toString());
                const processedRows = rows?.map((row, idx) => rowToObjectFunction(sourceSheetColumnIndexedKeys, row, idx)) ?? [];
                const columnIndexedKeys = getAllKeys(processedRows); //firstRowToHeaders( headerRow )
                const uniqueKeyTypes = getUniqueTypesMap(processedRows);
                const impliedViewDefinition = getViewDefinitionFromUniqueKeyTypes(uniqueKeyTypes);
                debug && console.log('uniqueKeyTypes', { uniqueKeyTypes, impliedViewDefinition });
                const gridColumnMap = viewDefinitionToGridColumnMap(impliedViewDefinition, false);
                setGridColumnMap(gridColumnMap);
                setProcessedSpreadsheetData(processedRows);
                setColumnHeaders(columnIndexedKeys);
            }
            else {
                console.log(`WARN: No header row!`);
            }
        }
    }, [spreadsheetData]);
    return {
        components: {
            ImportButton,
            WorkingSpinner,
        },
        state: {
            spreadsheetData: processedSpreadsheetData,
            gridColumnMap,
            columnHeaders,
            error,
        },
        handlers: {
            clearError,
        },
    };
};
